export default "__VITE_ASSET__DvQrp3Hs__"